export default {
  name:"flavio",
  builder:{},
  current:{},
  redeSocial:{},
  siteContent:{},
  agoraRadio:{},
  blocos:{}
}



// WEBPACK FOOTER //
// ./src/store/state.js